// modKey names the key the reader presses with a shortcut letter
export const modKey = /Mac|iP(hone|ad|od)/.test(navigator.userAgent) ? "⌘" : "Ctrl";
